export const getArrowType = (
  previousPeriodChange: number | null | undefined
) => {
  if (previousPeriodChange === 0 || !previousPeriodChange) {
    return undefined;
  }

  if (previousPeriodChange > 0) {
    return "increase";
  }

  if (previousPeriodChange < 0) {
    return "decrease";
  }
};
